import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";

import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { IFacetFilter } from "../ts/rlAdmin.filters";

export class BaseAssociationController<T> {
	
			entityRecord: Models.IEntity;
			entityID: string;
			templateID: number;
			templateIDString: string;
			recordID: number;
			charTypeID: number;
			divID: number;
			open: boolean;
			detailsUrl: string;
			previewEntityID: string;
			previewRecordID: number;
			private previewEntityRecord: Models.IEntity;
	
			search: {
				keywords: string;
				itemRows: T[];
				initialized: boolean;
				pageCount: number;
				selectedTemplate: string;
				templates: Models.IKeyValuePair<string, number>[];
				templateFacets: Models.IKeyValuePair<string, string>[];
				page: number;
				sortDir: number;
				sortField: string;
				rowsCheck: boolean;
				numFound: number;
			};
	
			entityCharDataCollection: Models.ICharDataCollection;
			visibility: number;
			editMode: boolean;
			initialized: boolean;
			nodes: Models.IEntityNodeWRelID[];
			modalOpen: boolean;
			selectedAssociatedIDs: number[];
			selectedSearchIDs: number[];
			selected: {
				associated: { [key: string]: boolean };
				search: { [key: number]: boolean };
			};
			self: any;
			canEdit: boolean;
			locked: boolean;
			public selectedPreviewEntity: Models.IEntityCharDataPair;
			rowCount: number;
	
			constructor(private $baseScope: ng.IScope, private $baseWindow: ng.IWindowService, private $baseFilter: ng.IFilterService, private $baseQ: ng.IQService, private baseNotifyService: NotifyService, private baseEntityService: EntityService, private baseEventService: EventService) {
				this.self = this;
				this.entityRecord = null;
				this.recordID = -1;
				this.charTypeID = -1;
				this.divID = -1;
				this.open = true;
				this.detailsUrl = "";
				this.search = {
					keywords: "",
					itemRows: [],
					initialized: false,
					pageCount: 0,
					selectedTemplate: "",
					templateFacets: [],
					templates: [],
					page: 1,
					sortDir: 0,
					sortField: "",
					rowsCheck: false,
					numFound: 0
				};
				this.previewEntityID = "";
				this.previewRecordID = -1;
				this.entityCharDataCollection = null;
				this.visibility = 1;
				this.editMode = false;
				this.initialized = false;
				this.nodes = [];
				this.modalOpen = false;
				this.selected = {
					associated: {},
					search: {}
				};
	
				this.canEdit = false;
				this.locked = false;
				this.rowCount = 10;
	
				$baseScope.$watch(() => this.modalOpen, (newValue, oldValue) => {
					if (newValue && !oldValue) {
						this.Search();
					}
				});
	
				$baseScope.$watch(() => [this.search.selectedTemplate, this.search.page, this.search.sortDir, this.search.sortField, this.rowCount],
					(newValue: any[], oldValue: any[]) => {
						if (newValue != oldValue) {
							if (newValue[0] != oldValue[0]) {
								this.search.page = 1;
							}
							this.Search();
						}
					}, true);
	
				$baseScope.$watch(() => this.selected.associated,
					(newValue, oldValue) => {
						this.selectedAssociatedIDs = _(newValue)
							.pairs()
							.filter((pair: any[]) => pair[1] === true)
							.map<string>((pair: any[]) => pair[0])
							.map<number>((relId) => {
								var id = Utils.IdBuilder.splitEntityID(relId);
								return id.recID || -1;
							})
							.filter((id: number) => id > 0)
							.valueOf();
					}, true);
	
				$baseScope.$watch(() => this.selected.search,
					(newValue, oldValue) => {
						this.selectedSearchIDs = _(newValue)
							.pairs()
							.filter((pair: any[]) => pair[1] === true)
							.map<number>((pair: any[]) => pair[0])
							.filter((id) => id > 0)
							.valueOf();
					}, true);
	
				$baseScope.$watch(() => this.search.rowsCheck,
					(newValue: boolean, oldValue: boolean) => {
						if (newValue != oldValue) {
							if (newValue) {
								_.forEach(this.search.itemRows, (itemRow) => {
									this.selected.search[this.SubGetRecordID(itemRow)] = true;
								});
							} else {
								this.selected.search = {};
							}
						}
					});
	
				$baseScope.$watch(() => this.previewEntityID,
					(newValue: string, oldValue: string) => {
						if (newValue != oldValue && !_.isEmpty(newValue)) {
							this.LoadDataAndPreviewEntity(this.previewEntityID);
						}
					}, true);
	
				$baseScope.$watch(() => this.search.templates,
					(newValue: Models.IKeyValuePair<string, number>[], oldValue: Models.IKeyValuePair<string, number>[]) => {
						if (newValue != oldValue) {
							this.search.templateFacets = $baseFilter<IFacetFilter>("facetFilter")(newValue);
						}
					}, true);
	
				$baseScope.$watch(() => {
					if (this.entityID == null) {
						return null;
					} else {
						return this.entityID;
					}
				},
					(newValue, oldValue) => {
						if (newValue != null) {
							this.baseEventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
								this.UpdateRecordStatus();
							});
						}
					});

				$baseScope.$on(Consts.Events.RefreshViewEntity, (e, data) => {					
						this.previewEntityID = data;					
				});
			}
	
			Init(entityID: string, templateID: number, detailsUrl: string, canEdit: string = "true") {
				this.entityID = entityID;
				var split = Utils.IdBuilder.splitEntityID(entityID);
				this.recordID = split.recID;
				this.charTypeID = split.charTypeID;
				this.divID = split.divID;
	
				this.templateIDString = Utils.IdBuilder.buildTemplateID(this.divID, this.charTypeID, templateID);
				this.detailsUrl = detailsUrl;
				this.canEdit = canEdit == "true";
	
				var promise1 = this.baseEntityService.getEntity(this.entityID)
					.then((result) => {
						this.entityRecord = result.record;
						if (result.charDataCollection != null) {
							if (result.charDataCollection.status.lockIndicator == 0) {
								this.locked = false;
							}
							else {
								this.locked = true;
							}
						}
					});
	
				var promise2 = this.GetAssociationHierarchy();
	
				this.$baseQ.all([promise1, promise2])
					.then(() => {
						this.initialized = true;
						this.previewEntityID = entityID;
					});
			}
	
			GetAssociationHierarchy() {
				this.baseNotifyService.startProgress();
				return this.SubGetAssociationHeirarchy()
					.then((result) => {
						this.nodes = [<Models.IEntityNodeWRelID>result];
					})
					.finally(() => {
						this.baseNotifyService.endProgress();
					});
			}
	
			// override this on parent classes
			SubGetAssociationHeirarchy(): ng.IPromise<Models.IEntityNode> {
				throw "SubGetAssociationHeirarchy Not implemented";
			}
	
			RemoveAssociated() {
				if (this.$baseWindow.confirm("Are you sure?")) {
					this.baseNotifyService.startProgress();
					this.SubRemoveAssociated()
						.then(() => {
							this.selected.associated = {};
							return this.GetAssociationHierarchy();
						})
						.then(() => {
							this.baseNotifyService.notifySuccess("Associated Record successfully removed.");
						})
						.finally(() => {
							this.baseNotifyService.endProgress();
						});
				} else {
					this.$baseScope.$broadcast(Consts.Events.NotifyDone);
				}
			}
	
			SubRemoveAssociated(): ng.IPromise<boolean> {
				throw "SubRemoveAssociated not implemented";
			}
	
			SetAssociated(direction: number) {
				this.baseNotifyService.startProgress();
				this.SubSetAssociated()
					.then(() => {
						this.selected.search = {};
						return this.GetAssociationHierarchy();
					})
					.then(() => {
						this.modalOpen = false;
						this.baseNotifyService.notifySuccess("Record successfully associated.");
					})
					.finally(() => {
						this.baseNotifyService.endProgress();
					});
			}
	
			SubSetAssociated(): ng.IPromise<boolean> {
				throw "SubSetAssociated not implemented";
			}
	
			Search() {
				var query: Models.IAdvancedSearchModel = {
					charTypeID: this.charTypeID,
					searchGroups: [],
					keywords: this.search.keywords,
					template: this.search.selectedTemplate,
					status: "",
					page: this.search.page,
					rowCount: this.rowCount,
					sortField: this.search.sortField || "",
					sortDir: this.search.sortDir || 0,
					notChildrenOfEntityID: this.entityID,
					associateToTemplate: this.templateIDString || "",
					excludeEntityID: this.entityID
				}
	
				this.baseNotifyService.startProgress(); // start	progress bar
	
				// call	search service
	
				this.SubSearch(query)
					.then((result) => {
						this.search.itemRows = result.documents;
						this.search.pageCount = Math.ceil(result.numFound / this.rowCount);
						this.search.templates = result.facetResults["template_meta"];
						this.search.numFound = result.numFound;
					})
					.finally(() => {
						this.search.initialized = true;	// mark	initialized	flag
						this.baseNotifyService.endProgress();		// end progress	bar
					});
			}
	
			SubSearch(request: Models.IAdvancedSearchModel): ng.IPromise<any> {
				throw "SubSearch not implemented";
			}
	
			SubGetRecordID(itemRow: T): number {
				throw "SubGetRecordID not implemented";
			}
	
			SelectNone() {
				this.selected.associated = {};
			}
	
			SelectAll() {
				this.selected.associated = {};
	
				var contextNode = this.FindContextEntity(this.nodes);
				if (contextNode != null) {
					_.forEach(contextNode.relatedEntities, (node: Models.IEntityNodeWRelID) => {
						this.selected.associated[node.relID] = true;
					});
				}
			}
	
			SelectToggle() {
				var contextNode = this.FindContextEntity(this.nodes);
				if (contextNode != null) {
					_.forEach(contextNode.relatedEntities, (node: Models.IEntityNodeWRelID) => {
						this.selected.associated[node.relID] = !this.selected.associated[node.relID] || false;
					});
				}
			}
	
			OpenModal() {
				this.modalOpen = true;
			}
	
			ShowEntity(entityID: string) {
				var hasDataAlready: boolean = (this.previewEntityID === entityID) && (this.previewEntityRecord != null) && (this.entityCharDataCollection != null);
				if (hasDataAlready) {					
					this.selectedPreviewEntity = {
						record: this.previewEntityRecord,
						charDataCollection: this.entityCharDataCollection
					};
				}
				else {
					this.previewEntityID = entityID;  // $watch on this will trigger data load / setting preview object
				}
				return;
			}
	
			FindContextEntity(nodes: Models.IEntityNode[]): Models.IEntityNode {
				var contextNode = _.find(nodes, (node: Models.IEntityNodeWRelID) => node.entity.recordID == this.recordID);
				if (contextNode != null) {
					return contextNode;
				}
	
				var result = null;
				_.forEach(nodes, (node) => {
					var result1 = this.FindContextEntity(_.values<Models.IEntityNode>(node.relatedEntities));
					if (result1 != null) {
						result = result1;
					}
				});
				return result;
			}
	
			private LoadDataAndPreviewEntity(entityID: string) {
	
				var previewRecordID: number = Utils.IdBuilder.splitEntityID(entityID).recID;
				var entity: Models.IEntity;
				var charData: Models.ICharDataCollection;
	
				var entityRecordPromise = this.baseEntityService.getEntityRecord(entityID)
					.then((result) => {
						entity = result;
					});
	
				var entityCharDataPromise = this.baseEntityService.getEntityCharData(entityID)
					.then((result) => {
						charData = result;
					});
	
				this.$baseQ.all([entityRecordPromise, entityCharDataPromise])
					.then(() => {
	
						this.previewRecordID = previewRecordID;
						this.previewEntityRecord = entity;
						this.entityCharDataCollection = charData;
	
						this.selectedPreviewEntity = {
							record: entity,
							charDataCollection: charData
						};
					});
	
				return;
			}
	
			UpdateRecordStatus() {
				this.baseEntityService.getEntity(this.entityID)
					.then((result) => {
						this.entityRecord = result.record;
						if (result.charDataCollection != null) {
							if (result.charDataCollection.status.lockIndicator == 0) {
								this.locked = false;
							}
							else {
								this.locked = true;
							}
						}
					});
			}
		}